/**
 * Shimmer utility for skeleton placeholders.
 *
 * Usage:
 *   <div className={cn("rounded-xl bg-white/[0.04] h-10", shimmer)} />
 *
 * The sweeping highlight is a ::before pseudo-element that slides across
 * the container. The keyframe `shimmer-pass` is defined in index.css so
 * we animate `translate-x` cleanly (Tailwind JIT-safe).
 *
 * Respects `prefers-reduced-motion` — the CSS rule in index.css disables
 * the sweep for users who opt out of motion.
 */
export const shimmer =
  "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer-pass_1.5s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/5 before:to-transparent";

/**
 * Soft gradient surface used underneath the shimmer sweep — avoids flat
 * grey placeholders by layering two subtle violet / neutral stops.
 */
export const skeletonSurface =
  "bg-[linear-gradient(135deg,rgba(255,255,255,0.04)_0%,rgba(167,139,250,0.05)_50%,rgba(255,255,255,0.03)_100%)]";

/** Combined base class for most skeleton blocks. */
export const skeletonBase = `${skeletonSurface} ${shimmer} rounded-[14px] border border-white/5`;
